import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ClientService } from 'app/services/client-service';
import { CommonsText } from 'app/commons/CommonsText';

export type NotificationChannel = 'SMS' | 'EMAIL' | 'NINGUNO';

@Component({
    selector: 'app-profile-notifications',
    templateUrl: './profile-notifications.component.html',
    styleUrls: ['./profile-notifications.component.scss']
})
export class ProfileNotificationsComponent implements OnInit {

    selected: NotificationChannel = 'NINGUNO';
    running = false;

    constructor(private clientService: ClientService,
                private toastr: ToastrService) {}

    ngOnInit(): void {
        const notifications = this.clientService.clientData && this.clientService.clientData.notifications;
        const channel = notifications && notifications.length > 0 ? notifications[0] : '';
        if (channel === 'SMS' || channel === 'EMAIL') {
            this.selected = channel;
        } else {
            this.selected = 'NINGUNO';
        }
    }

    select(channel: NotificationChannel): void {
        if (this.running || channel === this.selected) { return; }
        const previous = this.selected;
        this.selected = channel;
        this.running = true;

        this.clientService.onModifyNotifications(channel)
            .then(() => {
                this.running = false;
                this.toastr.success('Canal de notificaciones actualizado',
                    CommonsText.OPERACION_COMPLETADA, { timeOut: 4000 });
            })
            .catch(error => {
                this.running = false;
                this.selected = previous;
                const resp = error && error.error && error.error.response;
                const msg = resp ? resp.toString() : CommonsText.PROBLEMA_DE_CONECTIVIDAD;
                this.toastr.error(msg, CommonsText.ERROR_DE_OPERACION, { timeOut: 5000 });
            });
    }
}
